import React from "react";
import { CentredState, LoginButton } from "./Login";

export const VerifyEmail = () => {
  return (
    <CentredState
      lab="Verify email"
      title="Check your inbox"
      body="Please verify your email by clicking the link we sent you. If it isn't there, check your spam folder."
    >
      <LoginButton />
    </CentredState>
  );
};
